import { PRODUCT_CONTEXTS, type ProductContext } from '../common/constants';

/**
 * Minimal shape required to derive a product context. Decoupled from any
 * product-specific `TenantContext` type so this platform package stays free of
 * `@jira/*` dependencies. Callers passing a richer tenant-context object remain
 * structurally compatible.
 */
export type ProductContextInput = {
	readonly appPermissions?: {
		readonly hasSoftwareAccess?: boolean;
		readonly hasServiceDeskAccess?: boolean;
	};
};

/**
 * Derive the Assets product context from a tenant's app permissions.
 *
 * - Jira Software access (with or without JSM) resolves to the Jira context.
 * - Jira Service Management access (without Software) resolves to the JSM context.
 * - Neither resolves to `undefined`.
 */
export const getProductContext = (
	tenantContext: ProductContextInput,
): ProductContext | undefined => {
	const appPermissions = tenantContext.appPermissions ?? {};
	// Jira Software access (with or without JSM) resolves to the Jira product context.
	if (appPermissions.hasSoftwareAccess) {
		return PRODUCT_CONTEXTS.JIRA;
	}
	if (appPermissions.hasServiceDeskAccess) {
		return PRODUCT_CONTEXTS.JSM;
	}
};
